// Use state names from consts.js -> stateEntities
export default function () {
  return {
    mesh: {},
    cui: {},
    wui: {}
  };
}